import type { ConsultPaymentMethod, ConsultPaymentState } from '@/hooks/consult/useConsult';

export const isResendInvoiceVisible = ({
  ffEnableShopifyPayment,
  hasBeenInvoicedByEway,
  isPaymentInProgressOrCompleted,
}: {
  ffEnableShopifyPayment: boolean;
  isPaymentInProgressOrCompleted: boolean;
  hasBeenInvoicedByEway: boolean;
}) => {
  return (!ffEnableShopifyPayment || hasBeenInvoicedByEway) && isPaymentInProgressOrCompleted;
};

export const isShopifyPaymentVisible = ({
  ffEnableShopifyPayment,
  hasBeenInvoicedByEway,
  paymentState,
}: {
  ffEnableShopifyPayment: boolean;
  paymentState: ConsultPaymentState;
  hasBeenInvoicedByEway: boolean;
}) => {
  return ffEnableShopifyPayment && paymentState === 'IN_PROGRESS' && !hasBeenInvoicedByEway;
};

export const isNoShowVisible = ({
  isChargeableDoctorConsult,
  isPaymentInProgressOrCompleted,
  onPrescriptionCreationStep,
}: {
  isChargeableDoctorConsult: boolean;
  isPaymentInProgressOrCompleted: boolean;
  onPrescriptionCreationStep: boolean;
}) => {
  if (isChargeableDoctorConsult) {
    return !isPaymentInProgressOrCompleted && onPrescriptionCreationStep;
  }

  return onPrescriptionCreationStep;
};

export const isCancelVisible = ({
  isChargeableDoctorConsult,
  isPaymentInProgressOrCompleted,
  onPrescriptionCreationStep,
  showStatusSelector,
  ffAwaitingDocument,
}: {
  isChargeableDoctorConsult: boolean;
  isPaymentInProgressOrCompleted: boolean;
  onPrescriptionCreationStep: boolean;
  showStatusSelector: boolean;
  ffAwaitingDocument: boolean;
}) => {
  if (!showStatusSelector && ffAwaitingDocument) {
    return true;
  }

  if (isChargeableDoctorConsult) {
    return !isPaymentInProgressOrCompleted && !onPrescriptionCreationStep;
  }

  return !onPrescriptionCreationStep;
};

export const isPaymentButtonDisabled = ({
  processingPayment,
  paymentMethod,
  paymentState,
}: {
  processingPayment: boolean;
  paymentMethod: ConsultPaymentMethod;
  paymentState: ConsultPaymentState;
}) => processingPayment || (paymentMethod === 'CREDIT_CARD' && paymentState === 'IN_PROGRESS');
